var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4362 0.763604C5.78767 1.11508 5.78767 1.68492 5.4362 2.0364L2.4726 5L5.4362 7.9636C5.78767 8.31508 5.78767 8.88492 5.4362 9.2364C5.08473 9.58787 4.51488 9.58787 4.16341 9.2364L0.563409 5.6364C0.211937 5.28492 0.211937 4.71508 0.563409 4.3636L4.16341 0.763604C4.51488 0.412132 5.08473 0.412132 5.4362 0.763604Z",
    fill: "#8F9BBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.b05589e03349fafaf330e29dc30783d1.svg";
export { ForwardRef as ReactComponent };